import posthog from 'posthog-js';

const posthogApiKey = process.env.POSTHOG_API_KEY;
const posthogHost = process.env.POSTHOG_HOST || 'https://us.i.posthog.com';

if (posthogApiKey) {
    posthog.init(posthogApiKey, {
        api_host: posthogHost,
        capture_exceptions: true,
    });
}

export function analyticsUserId(value) {
    const normalized = String(value || '').trim().toLowerCase();
    let hash = 2166136261;
    for (let i = 0; i < normalized.length; i += 1) {
        hash ^= normalized.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }
    return normalized ? `user_${(hash >>> 0).toString(16)}` : '';
}

export default posthog;
